import { PublicClientApplication } from '@azure/msal-browser';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import { isMockMode, mockAllowed, MockAuthProvider, MsalAuthProvider } from './auth';
import { config } from './config';
import { applyTheme, storedTheme } from './theme';
import './app.css';

applyTheme(storedTheme());

const root = createRoot(document.getElementById('root')!);

async function start() {
  if (isMockMode()) {
    // Test builds only; never served from a deployed environment.
    if (!mockAllowed()) {
      root.render(<p style={{ padding: 16 }}>This test build only runs on localhost.</p>);
      return;
    }
    root.render(
      <StrictMode>
        <MockAuthProvider>
          <App />
        </MockAuthProvider>
      </StrictMode>,
    );
    return;
  }
  if (!config.clientId || !config.tenantId) {
    root.render(<p style={{ padding: 16 }}>Configuration missing: set VITE_ENTRA_TENANT_ID and VITE_ENTRA_CLIENT_ID.</p>);
    return;
  }
  const msal = new PublicClientApplication({
    auth: {
      clientId: config.clientId,
      authority: `https://login.microsoftonline.com/${config.tenantId}`,
      redirectUri: `${window.location.origin}/`,
      postLogoutRedirectUri: `${window.location.origin}/`,
    },
    cache: { cacheLocation: 'sessionStorage' },
  });
  await msal.initialize();
  const result = await msal.handleRedirectPromise();
  if (result?.account) msal.setActiveAccount(result.account);
  if (!msal.getActiveAccount()) {
    const first = msal.getAllAccounts()[0];
    if (first) msal.setActiveAccount(first);
  }
  root.render(
    <StrictMode>
      <MsalAuthProvider msal={msal}>
        <App />
      </MsalAuthProvider>
    </StrictMode>,
  );
}

void start();
